import { Suppliers } from './Suppliers/index';

export const ManageSuppliers = () => {
    return (
        <div className="admin-panel__table-container">
            <Suppliers />
        </div>
    );
};
